import { READ, FORM_UPDATE } from '../../../../store/type'
import { MAIN_CONTACT } from "./type";
export const mutations = {
    [MAIN_CONTACT + READ]: (state, { data, fieldInfoList }) => {
        state.data = data
        state.fieldInfoList = fieldInfoList
    }
};